module.exports = __webpack_public_path__ + "img/58-l.18623735.png";